import { render, staticRenderFns } from "./investorList.vue?vue&type=template&id=1d4917de&scoped=true&"
import script from "./investorList.vue?vue&type=script&lang=js&"
export * from "./investorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4917de",
  null
  
)

export default component.exports